import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const viewSection = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('school-management/class-management/section/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const activeSection = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('section/active/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addSection = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('school-management/class-management/section/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getSection = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('section/edit/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const editSection = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('school-management/class-management/section/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const toggleSection = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('school-management/class-management/section/status/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
